import React from 'react';
import { WebsiteDesignProps } from './types';
import { Blocks, Bird, CloudSun, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MontessoriPlay: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Little Sprouts Montessori";

    return (
        <div className="bg-[#E4F1EE] text-[#5D5D5D] min-h-screen font-sans selection:bg-[#FFB7B2]">
             <nav className="p-6 md:p-10 flex justify-between items-center">
                 <div className="text-2xl font-bold text-[#8AA29E] flex items-center gap-2">
                     <Bird size={32} /> {schoolName}
                 </div>
                 <Button className="bg-[#FFB7B2] hover:bg-[#ff9e99] text-white rounded-full px-6 text-lg font-bold shadow-[4px_4px_0px_#fff]">
                     Enroll Now
                 </Button>
             </nav>

             <main className="container mx-auto px-6 py-10 flex flex-col items-center text-center">
                 <div className="bg-white p-4 rounded-full shadow-[8px_8px_0px_#e0e0e0] mb-8 animate-bounce">
                     <CloudSun size={48} className="text-[#FFdac1]" />
                 </div>
                 <h1 className="text-5xl md:text-7xl font-bold text-[#68869A] mb-8 tracking-tight">
                     Play. Learn. <br/> Grow.
                 </h1>
                 <p className="text-xl text-[#8AA29E] max-w-lg mb-12 font-medium">
                     Nurturing independence and a love for learning in a prepared environment designed just for them.
                 </p>

                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-6xl">
                     <div className="bg-[#FFDAC1] rounded-[2rem] p-8 min-h-[300px] flex flex-col items-center justify-center shadow-lg hover:-translate-y-2 transition-transform">
                         <Blocks size={64} className="text-white mb-6 opacity-80" />
                         <h3 className="text-2xl font-bold text-white mb-2">Hands On</h3>
                         <p className="text-white/80 font-medium">Learning through touch and interaction.</p>
                     </div>
                     <div className="bg-[#B5EAD7] rounded-[2rem] p-8 min-h-[300px] flex flex-col items-center justify-center shadow-lg hover:-translate-y-2 transition-transform">
                          <img src="https://images.unsplash.com/photo-1596464716127-f9a8759d1b28?q=80&w=2074&auto=format&fit=crop" className="w-full h-full object-cover rounded-xl filter sepia-[0.3] opacity-80" alt="Kids" />
                     </div>
                     <div className="bg-[#C7CEEA] rounded-[2rem] p-8 min-h-[300px] flex flex-col items-center justify-center shadow-lg hover:-translate-y-2 transition-transform">
                         <Star size={64} className="text-white mb-6 opacity-80" />
                         <h3 className="text-2xl font-bold text-white mb-2">Individual Pace</h3>
                         <p className="text-white/80 font-medium">Respecting each child's unique timeline.</p>
                     </div>
                 </div>
             </main>
        </div>
    );
};

export default MontessoriPlay;
